// Registration only. Alpine's own start() and MutationObserver initialize the
// DOM, so this must run before Alpine is fetched (see the section template).
function registerServiceCreditTiers() {
  if (!window.Alpine || window.__serviceCreditTiersRegistered) return;

  window.__serviceCreditTiersRegistered = true;

  window.Alpine.data('serviceCreditTiers', (config = {}) => ({
    currency: config.currency || 'USD',
    bonusLabel: config.bonusLabel || 'Reward Dollars',
    error: '',

    quantity: 1,
    location: '',

    buyerFirstName: '',
    buyerLastName: '',
    buyerEmail: '',
    buyerPhone: '',

    selectedVariantId: '',
    selectedLabel: '',
    selectedPriceCents: 0,
    selectedBonusCents: 0,

    init() {
      const form = this.$el.closest('form');
      if (!form || form.__sctBound) return;

      // The form is `novalidate`, so pressing Enter in any field submits it
      // directly. Guard every submission here rather than on the button alone.
      form.__sctBound = true;
      form.addEventListener(
        'submit',
        (event) => {
          if (this.isValid()) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        true
      );
    },

    selectTier(el) {
      this.selectedVariantId = el.dataset.variantId || '';
      this.selectedLabel = el.dataset.label || '';
      this.selectedPriceCents = parseInt(el.dataset.priceCents, 10) || 0;
      this.selectedBonusCents = parseInt(el.dataset.bonusCents, 10) || 0;
      this.error = '';
    },

    increaseQty() {
      this.quantity = this.safeQuantity + 1;
      this.error = '';
    },

    decreaseQty() {
      if (this.safeQuantity > 1) this.quantity = this.safeQuantity - 1;
      this.error = '';
    },

    get safeQuantity() {
      const parsed = parseInt(this.quantity, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    },

    get subtotalCents() {
      return this.selectedPriceCents * this.safeQuantity;
    },

    get bonusCents() {
      return this.selectedBonusCents * this.safeQuantity;
    },

    get totalCreditCents() {
      return this.subtotalCents + this.bonusCents;
    },

    get subtotalMoney() {
      return this.formatMoney(this.subtotalCents);
    },

    get bonusMoney() {
      return this.formatMoney(this.bonusCents);
    },

    get totalCreditMoney() {
      return this.formatMoney(this.totalCreditCents);
    },

    formatMoney(cents) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.currency
      }).format(cents / 100);
    },

    isValid() {
      this.error = '';

      if (!this.buyerFirstName.trim()) {
        this.error = 'Please enter your first name.';
        return false;
      }

      if (!this.buyerLastName.trim()) {
        this.error = 'Please enter your last name.';
        return false;
      }

      if (!this.buyerEmail.trim()) {
        this.error = 'Please enter your email.';
        return false;
      }

      if (!this.isValidEmail(this.buyerEmail.trim())) {
        this.error = 'Please enter a valid email.';
        return false;
      }

      if (!this.buyerPhone.trim()) {
        this.error = 'Please enter your phone number.';
        return false;
      }

      // The selector is only rendered when locations are configured, so an
      // empty value here means the merchant listed some and none was chosen.
      if (this.$el.querySelector('[x-model="location"]') && !this.location) {
        this.error = 'Please choose a location.';
        return false;
      }

      if (!this.selectedVariantId) {
        this.error = 'Please choose a credit amount.';
        return false;
      }

      if (this.safeQuantity < 1) {
        this.error = 'Quantity must be at least 1.';
        return false;
      }

      return true;
    },

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
  }));

}

if (window.Alpine) {
  registerServiceCreditTiers();
} else {
  document.addEventListener('alpine:init', registerServiceCreditTiers);
}
